import React from 'react';
/*
This component is used in
components/common/dropdowncomponents/dataexportdropdown/heatmapexport.jsx
components/common/dropdowncomponents/dataexportdropdown/statsexport.jsx
components/common/dropdowncomponents/dataexportdropdown/widgetexport.jsx
components/common/dayselector.jsx
components/common/dropdowncomponents/listdropdown.jsx
components/common/modeselector.jsx
components/common/dropdowncomponents/nodedropdown.jsx
components/common/dropdowncomponents/roomtypeselector.jsx
components/common/tagselector.jsx
*/
const DropdownItem = (props) => {
  return (
    <div style={props.style ? props.style : {}} className={`dropdown__item ${props.className ? props.className : ''}`}>
      {props.children}
    </div>
  );
}

export default DropdownItem



// WEBPACK FOOTER //
// ./src/components/common/dropdowncomponents/dropdownitem.jsx